export default "__VITE_ASSET__BtC_z9hn__"